<i-title [text]="'Recherche avancée'"></i-title>


@if(!fetchingRights()) {
<div class="points-advanced-search" [formGroup]="advancedSearchFormGroup">
    <div class="points-advanced-search__actions mb-2">
        <idel-actions [canSave]="isAdvancedSearchFormNotEmpty" (actionClick)="onActionClick($event)"></idel-actions>
    </div>
    <div class="points-advanced-search__general-informations card">
        <idel-general-data [form]="advancedSearchFormGroup.controls.generalData"
            [rights]="rights()"></idel-general-data>
    </div>
    <div class="points-advanced-search__saved-searches card">
        <idel-saved-searches (onClick)="populateFormsFromSavedSearch($event)" [(refresh)]="shouldRefreshSavedSearch"
            (refreshDashboard)="refreshDashboard.emit()"></idel-saved-searches>
    </div>
    <div class="points-advanced-search__meeting card">
        <idel-meeting-search-for-points
            [form]="advancedSearchFormGroup.controls.meeting"></idel-meeting-search-for-points>
    </div>
    <div class="points-advanced-search__more-data card">
        <idel-more-data [form]="advancedSearchFormGroup.controls.moreData" [rights]="rights()"
            [services]="advancedSearchFormGroup.controls.generalData.value?.services ?? []"></idel-more-data>
    </div>
    <div class="points-advanced-search__agents card">
        <idel-agents [form]="advancedSearchFormGroup.controls.agents"></idel-agents>
    </div>
</div>

}@else {
<div class="d-flex align-items-center justify-content-center w-100" style="height: 50dvh;">
    <i-loader></i-loader>
</div>
}

<p-dialog [header]="'Sauver la recherche avancée'" [(visible)]="showNewSavedSearchForm">
    <div class="d-flex flex-column" [formGroup]="savedSearchForm">
        <div class="d-flex flex-column mb-2">
            <label class="input-label">Description*</label>
            <input pInputText formControlName="description" />
        </div>
        <div class="d-flex flex-column mb-2">
            <label class="input-label">Ordre d'affichage</label>
            <p-inputNumber formControlName="order" />
        </div>
        <div class="d-flex flex-row align-items-center gap-2 mb-2">
            <p-checkbox formControlName="hideInDashboard" [binary]="true"></p-checkbox>
            <label class="input-label mb-0">Cacher dans le dashboard</label>
        </div>
        <div class="d-flex justify-content-end">
            <i-button [styleClass]="'blue'" [text]="'Sauver'" (click)="onSaveNewSavedSearch()"
                [disabled]="savedSearchForm.invalid"></i-button>
        </div>
    </div>
</p-dialog>